export { default } from './BlurredText';
